import { Button, Typography } from '@mui/material'
import isFunction from 'lodash/isFunction'
import React from 'react'
import { Query } from 'react-apollo'
import { RouteComponentProps } from 'react-router'
import { withRouter } from 'react-router-dom'
import Loader from '../../../common/loader/Loader'
import withPermission from '../../auth/withPermission'
import { i18n } from '../../index'
import { fetchStation } from '../../station/stationQueries'
import type { Station } from '../../station/stationTypes'
import css from './stationPage.css'

type StationPageProps = {
  title: string
  history: any
  match: any
  children: any
  hasPermission?: boolean
}

@withPermission('manage_stations')
class StationPage extends React.Component<RouteComponentProps & StationPageProps> {
  render() {
    const { title, match, history, children, hasPermission } = this.props

    return (
      <div className={css.component}>
        <div className={css.top}>
          <Typography className={css.title} variant='h6'>
            {title}
          </Typography>
          {hasPermission && (
            <Button
              color='secondary'
              variant='contained'
              onClick={() => {
                history.push('/yllapito/toimipaikat')
              }}
              disableRipple
            >
              {i18n.t('admin.stations.label.backButton')}
            </Button>
          )}
        </div>
        {isFunction(children) ? (
          <Query<
            {
              station: Station
            },
            {
              id: string
            }
          >
            query={fetchStation}
            variables={{
              id: match.params.stationId,
            }}
            fetchPolicy={'cache-and-network'}
          >
            {({ data, error, loading }) => (
              <Loader
                {...{
                  error,
                  loading,
                }}
              >
                {data &&
                  data.station &&
                  children({
                    station: data.station,
                  })}
              </Loader>
            )}
          </Query>
        ) : (
          children
        )}
      </div>
    )
  }
}

export default withRouter(StationPage)
